import React, { useState } from 'react';
import styled from 'styled-components';
import colors from 'utils/colors';
import { DatePicker } from '@blueprintjs/datetime';
import { Popover, Button, NonIdealState } from '@blueprintjs/core';
import moment from 'moment';

const DisplayDate = ({ date }) => (
  <H2>
    {moment(date).isValid() ? moment(date).format('MMMM Do YYYY') : 'N/A'}
  </H2>
);

const DisplayDateRow = ({
  renewalDate,
  productServiceName,
  editing,
  handleDateChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openDatePicker = () => setIsOpen(true);
  const closeDatePicker = () => setIsOpen(false);

  return (
    <DateContainer>
      <span>{productServiceName}</span>
      <Muted>Upcoming Renewal Date</Muted>
      {editing ? (
        <React.Fragment>
          <Popover isOpen={isOpen} onClose={closeDatePicker}>
            <div>
              <DisplayDate date={renewalDate} />
              <Button onClick={openDatePicker} text="Select Date" />
            </div>

            <DatePicker
              showActionsBar
              onChange={date => handleDateChange(date)}
            />
          </Popover>
        </React.Fragment>
      ) : (
        <DisplayDate date={renewalDate} />
      )}
    </DateContainer>
  );
};

const Row = ({
  renewalDate,
  productServiceName,
  editing,
  handleDateChange,
}) => {
  return renewalDate === null ? (
    <NonIdealState
      title="No renewal dates found"
      description="There are no assessments for this Third Party."
    />
  ) : (
    <DisplayDateRow
      renewalDate={renewalDate}
      productServiceName={productServiceName}
      editing={editing}
      handleDateChange={handleDateChange}
    />
  );
};

const DateContainer = styled.div`
  margin: 0.2rem;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  width: 90%;

  & span {
    font-size: 0.9rem;
  }
`;

const Muted = styled.div`
  color: ${colors.muted};
`;

const H2 = styled.h2`
  margin: 0.3rem;
  color: ${colors.darkGray};
`;

export default Row;
